/* eslint-disable no-unused-vars */
const direction = {
    left:(w,h,lw,lh)=>({w:w+lw,h:h}),
    right:(w,h,lw,lh)=>({w:w-lw,h:h}),
    bottom:(w,h,lw,lh)=>({w:w,h:h-lh}),
    top:(w,h,lw,lh)=>({w:w,h:h+lh})
}
const directionStyle = {
    left:(e)=>{
        e.style.right = '0px'
        e.style.top = '50%'
        e.style.cursor = 'e-resize';
        e.style.height = '60px'
        e.style.width= '5px'
    },
    right:(e)=>{
        e.style.left = '0px'
        e.style.top = '50%'
        e.style.cursor = 'e-resize';
        e.style.width= '5px'
        e.style.height = '60px'
    },
    bottom:(e)=>{
        e.style.left = '50%'
        e.style.top = '0px'
        e.style.cursor = 's-resize';
        e.style.width = '60px'
        e.style.height= '5px'
    },
    top:(e)=>{
        e.style.left = '50%'
        e.style.bottom = '0px'
        e.style.cursor = 's-resize';
        e.style.width = '60px'
        e.style.height= '5px'
    },
}
export default{
    mounted: function (el,binding) {
        el.style.position = 'relative'
        const mv = document.createElement('div')
        mv.style.position = 'absolute'
        // mv.style.backgroundColor='red'
        mv.style.borderRadius = '20%'
        mv.style.border = '1px solid #0099CC'
        directionStyle[binding.value||'left'](mv)
        // mv.appendChild(document.createTextNode('+'))
        el.appendChild(mv)
        const dragDom = mv;
      
        
        dragDom.onmousedown = (e) => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX
            const disY = e.clientY
            const w = el.clientWidth
            const h = el.clientHeight
            var nw;
            var nh;
            document.onmousemove = function(e) {
                // 通过事件委托，计算移动的距离
                const lw = e.clientX - disX
                const lh = e.clientY - disY
                // 改变当前元素宽度，不可超过最小最大值
                const r = direction[binding.value||'left'](w,h,lw,lh)
                if(!binding.value || binding.value == 'left'||binding.value == 'right'){
                    nw = r.w
                    el.style.width = `${nw}px`
                }else{
                    nh = r.h
                    el.style.height = `${nh}px`
                }
            }
    
            // eslint-disable-next-line no-unused-vars
            document.onmouseup = function(e) {
                document.onmousemove = null
                document.onmouseup = null
            }
        }
    },
    // unmounted(el){
	// 	el.removeEventListener('click', el.handler)
	// }
}